import { colours } from "./colours";
import { mediaQuery } from "./deviceDimensions";

// The base font sizes are what the html tag's font size is set to at
// the specified break points
export const BASE_FONT_SIZE_MOBILE = 14;
export const BASE_FONT_SIZE_TABLET = 16;

export const pxToRem = (px, breakpoint = "mobile") => {
	let baseFontSize = BASE_FONT_SIZE_MOBILE;

	switch (breakpoint) {
		case "tablet":
		case "desktop":
			baseFontSize = BASE_FONT_SIZE_TABLET;
			break;
		default:
			break;
	}

	return `${px / baseFontSize}rem`;
};

/**
 * Pixel values of font sizes for each breakpoint's text styles.
 * Note: 'desktop' sizes are same as 'tablet'.
 */
export const fontSizes = {
	mobile: {
		HEADING1: 30,
		HEADING1_5: 1.25,
		HEADING2: 1.25,
		LARGE: 18,
		BASE: 14,
		SEMISMALL: 13,
		SMALL: 12,
	},
	tablet: {
		HEADING1: 30,
		HEADING1_5: 18,
		HEADING2: 18,
		LARGE: 18,
		BASE: 15,
		SEMISMALL: 13,
		SMALL: 12,
	},
};

export const buyFlowTextStyles = {
	HEADING1_5: `
    color: ${colours.MIDNIGHT_BLUE};
    font-family: var(--euclid-medium);
    font-size: ${fontSizes.mobile.HEADING1_5}rem;
    line-height: 1.35em;
	font-weight: 500 !important;

	${mediaQuery.tabletAndUp} {
      font-size: ${pxToRem(fontSizes.tablet.HEADING1_5, "tablet")};
    }
  `,
	HEADING1: `
    color: ${colours.MIDNIGHT_BLUE};
    font-family: var(--taviraj-light);
    font-size: ${fontSizes.mobile.HEADING1}px;
    line-height: 1.15em;
    -webkit-font-smoothing: subpixel-antialiased;
	font-weight: 300 !important;

	${mediaQuery.tabletAndUp} {
      font-size: ${pxToRem(fontSizes.tablet.HEADING1, "tablet")};
    }
  `,
	HEADING2: `
    color: ${colours.MIDNIGHT_BLUE};
    font-family: var(--euclid-medium);
    font-size: ${fontSizes.mobile.HEADING2}rem;
    line-height: 1.35em;
	font-weight: 500 !important;

	${mediaQuery.tabletAndUp} {
      font-size: ${pxToRem(fontSizes.tablet.HEADING2, "tablet")};
    }
  `,
	LARGE: `
    color: ${colours.MIDNIGHT_BLUE};
    font-family: var(--euclid-regular);
    font-size: ${fontSizes.mobile.LARGE}px;
    line-height: 1.35em;

	${mediaQuery.tabletAndUp} {
      font-size: ${pxToRem(fontSizes.tablet.LARGE, "tablet")};
    }
  `,
	BASE: `
    color: ${colours.MIDNIGHT_BLUE};
    font-family: var(--euclid-regular);
    font-size: ${fontSizes.mobile.BASE}px;
    line-height: 1.35em;
	font-weight: 400 !important;

	${mediaQuery.tabletAndUp} {
      font-size: ${pxToRem(fontSizes.tablet.BASE, "tablet")};
    }
  `,
	SMALL: `
    color: ${colours.MIDNIGHT_BLUE};
    font-family: var(--euclid-regular);
    font-size: ${fontSizes.mobile.SMALL}px;
    line-height: 1.25em;
	font-weight: 400 !important;

	${mediaQuery.tabletAndUp} {
      font-size: ${pxToRem(fontSizes.tablet.SMALL, "tablet")};
    }
  `,
	SEMISMALL: `
    color: ${colours.MIDNIGHT_BLUE};
    font-family: var(--euclid-regular);
    font-size: ${fontSizes.mobile.SEMISMALL}px;
    line-height: 1.25em;
	font-weight: 400 !important;

	${mediaQuery.tabletAndUp} {
      font-size: ${pxToRem(fontSizes.tablet.SEMISMALL, "tablet")};
    }
  `,
};
